import {
  create_staff_operation_target,
  update_staff_operation_target,
  query_staff_operation_target_list,
} from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-staff_operation_target-config';

import { reactive } from 'vue';
import moment from "moment";

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: moment().format('YYYY-MM-01'),
    shop_id: null,
    pageSize:2000,
  }),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '员工',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'number',
      name: 'yye_target_amount',
      label: '营业额目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写营业额目标',
    },
    {
      type: 'number',
      name: 'kl_target_count',
      label: '客流目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写客流目标',
    },
    {
      type: 'number',
      name: 'rt_target_count',
      label: '人头目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写人头目标',
    },
    {
      type: 'number',
      name: 'xhy_target_count',
      label: '新会员目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写新会员目标',
    },
  ],
  rules: {
    date: [{ required: true, message: '请填预约会员姓名' }],
    yye_target_amount: [{ required: true, message: '请填写营业额目标' }],
    kl_target_count: [{ required: true, message: '请填客流目标' }],
    rt_target_count: [{ required: true, message: '请填写人头目标' }],
    xhy_target_count: [{ required: true, message: '请填写新会员目标' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date: null,
    staff_id: null,
    yye_target_amount: null,
    kl_target_count: null,
    rt_target_count: null,
    xhy_target_count: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 17,
    },
  },
  fields: [
    {
      type: 'monthpicker',
      name: 'date',
      label: '月份',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM',
      valueFormat: 'YYYY-MM-01',
      placeholder: '请选择月份',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '员工',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'number',
      name: 'yye_target_amount',
      label: '营业额目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写营业额目标',
    },
    {
      type: 'number',
      name: 'kl_target_count',
      label: '客流目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写客流目标',
    },
    {
      type: 'number',
      name: 'rt_target_count',
      label: '人头目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写人头目标',
    },
    {
      type: 'number',
      name: 'xhy_target_count',
      label: '新会员目标',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写新会员目标',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    yye_target_amount: null,
    kl_target_count: null,
    rt_target_count: null,
    xhy_target_count: null,
    staff_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '客户运营目标',
  addModalTitle: '新建客户运营目标',
  updateTitle: '编辑客户运营目标',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    staff_operation_target_id: 'id',
  },
  delete: {
    staff_operation_target_id: 'id',
  },
  recover: {
    staff_operation_target_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    staff_operation_target_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '月份',
    dataIndex: 'date',
    width: 100,
  },
  {
    title: '员工编号',
    width: 120,
    dataIndex: 'staff__code',
    checked: true,
  },
  {
    title: '员工姓名',
    width: 120,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '营业额目标',
    width: 120,
    dataIndex: 'yye_target_amount',
    checked: true,
  },
  {
    title: '客流目标',
    width: 120,
    dataIndex: 'kl_target_count',
    checked: true,
  },
  {
    title: '人头目标',
    width: 120,
    dataIndex: 'rt_target_count',
    checked: true,
  },
  {
    title: '新会员目标',
    width: 120,
    dataIndex: 'xhy_target_count',
    checked: true,
  },
  {
    title: '操作',
    width: 80,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_staff_operation_target_list,
    addData: create_staff_operation_target,
    updateData: update_staff_operation_target,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
